import React, { useMemo, FC } from 'react';
import { TNewsListingProps, TSelectedNewsFilters } from './types/newsListing.types';
import { NewsListingModel } from './models/newsListing.model';
import DesktopFilter from './components/desktopFilter';
import { BreakpointsInPx } from '../../constants/breakpoints.constants';
import useMediaQuery from '../../hooks/useMediaQuery';
import MobileFilter from './components/mobileFilter';
import { QueryParamsConst } from '../../constants/query-params.constants';
import UnreleasedComponent from '../@shared/unreleasedComponent';
import { updateSearchResults } from '../../hooks/useQueryParams.effect';
import NewsCardList from './components/newsCardList';
import NoMatch from '../@shared/filters/components/noMatch';
import Pagination from '../@shared/pagination';
import { useLocation, useNavigate } from 'react-router';
import './styles.scss';

const NewsListing: FC<TNewsListingProps> = (props) => {
  const model = new NewsListingModel(props);
  const isWide = useMediaQuery(`(min-width: ${BreakpointsInPx['tbl-l']})`);
  const navigate = useNavigate();
  const location = useLocation();
  const filterQueryString = location?.search;
  const filterParams = useMemo(() => new URLSearchParams(location?.search), [filterQueryString]);
  const year = filterParams.get(QueryParamsConst.YEAR) || '';
  const line = model.findFilterByName('line')?.hidden ? '' : filterParams.get(QueryParamsConst.LINE) || '';
  const type = model.findFilterByName('type')?.hidden ? '' : filterParams.get(QueryParamsConst.TYPE) || '';
  const industry = model.findFilterByName('industry')?.hidden ? '' : filterParams.get(QueryParamsConst.INDUSTRY) || '';
  const pageNo = filterParams.get(QueryParamsConst.PAGE) || '1';
  const noOfCardsPerPage = 6;
  const totalPageCount = Math.ceil(model.counter / noOfCardsPerPage);

  const { YEAR, LINE, TYPE, INDUSTRY } = QueryParamsConst;
  const selectedFilters: TSelectedNewsFilters = {
    [YEAR]: year,
    [LINE]: line,
    [TYPE]: type,
    [INDUSTRY]: industry,
  };

  // Component is unreleased
  if (model.isUnreleased) {
    return <UnreleasedComponent />;
  }

  const onPaginationChange = (selectedPage: number): void =>
    updateSearchResults(navigate, { [QueryParamsConst.PAGE]: selectedPage.toString() });

  return (
    <div className="news-listing">
      {isWide ? (
        <DesktopFilter model={model} selectedFilters={selectedFilters} />
      ) : (
        <MobileFilter model={model} selectedFilters={selectedFilters} />
      )}
      <div className="news-listing__card-container">
        <NewsCardList items={model?.items} />
      </div>
      {model?.items?.length === 0 && (
        <NoMatch titleDictionaryKey="cnhi-news-no-matches-found-title" descriptionDictionaryKey="cnhi-news-no-matches-found-description" />
      )}
      <Pagination currentPage={parseInt(pageNo)} pages={totalPageCount} goToPage={onPaginationChange} />
    </div>
  );
};

export default NewsListing;
